import React from "react";
import { Container, Typography, Button, Box, Grid, Paper, useTheme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ShieldIcon from '@mui/icons-material/Shield';
import SpeedIcon from '@mui/icons-material/Speed';
import DevicesIcon from '@mui/icons-material/Devices';
import HerosectionOne from '../Assets/Rockkpay/HeroSection/HerosectionOne.jpg';
import HerosectionTwoo from '../Assets/Rockkpay/HeroSection/HerosectionTwo.png';
import HerosectionTwo from '../Assets/Rockkpay/HeroSection/paymentsolution.jpg'
import { useNavigate } from "react-router-dom";

// Styled components
const GradientButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(45deg, #f59e0b, #f97316)',
  color: 'white',
  fontWeight: 700,
  padding: '14px 30px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '1rem',
  transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  boxShadow: '0 10px 25px rgba(249, 115, 22, 0.4)',
  position: 'relative',
  overflow: 'hidden',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    transition: 'all 0.6s ease',
  },
  '&:hover': {
    background: 'linear-gradient(45deg, #ea580c, #ef4444)',
    transform: 'translateY(-5px)',
    boxShadow: '0 15px 30px rgba(249, 115, 22, 0.5)',
    '&:before': {
      left: '100%',
    },
  },
 
}));

const OutlinedButton = styled(Button)(({ theme }) => ({
  border: '2px solid rgba(255, 255, 255, 0.7)',
  color: 'white',
  fontWeight: 600,
  padding: '13px 28px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '1rem',
  transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  position: 'relative',
  overflow: 'hidden',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.1)',
    transform: 'scaleX(0)',
    transformOrigin: 'left',
    transition: 'transform 0.4s ease',
  },
  '&:hover': {
    borderColor: 'rgba(255, 255, 255, 0.9)',
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 25px rgba(255, 255, 255, 0.15)',
    '&:before': {
      transform: 'scaleX(1)',
    },
  },
}));

const FeatureCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  borderRadius: '16px',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.15)',
  },
}));

const IconBox = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #dbeafe, #eff6ff)',
  borderRadius: '20px',
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(3),
  color: '#3b82f6',
  transition: 'all 0.5s cubic-bezier(0.19, 1, 0.22, 1)',
  boxShadow: '0 10px 20px rgba(59, 130, 246, 0.1)',
  '&:hover': {
    transform: 'scale(1.1) rotate(5deg)',
    boxShadow: '0 15px 30px rgba(59, 130, 246, 0.2)',
    background: 'linear-gradient(135deg, #bfdbfe, #dbeafe)',
  },
}));

const HeroSectionTwo = () => {
    const navigate=useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const handleLoginClick = () => {
    navigate("/signin");
  };

  return (
    <Box
     id="Home-Section-One"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        bgcolor: '#0f172a',
        color: '#fff',
        pt: { xs: 12, md: 16 },
        pb: { xs: 10, md: 14 },
      }}
    >
      {/* Background gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at top right, rgba(51, 65, 85, 0.8), rgba(15, 23, 42, 0.9))',
          zIndex: 1,
        }}
      />

      {/* Background image */}
      <Box
        component="img"
        src={HerosectionOne}
        alt="Background"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          opacity: 0.3,
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  color: '#60a5fa',
                  fontWeight: 600,
                  mb: 2,
                  display: 'inline-block',
                  p: 1,
                  px: 2,
                  borderRadius: '20px',
                  bgcolor: 'rgba(96, 165, 250, 0.1)',
                }}
              >
                Next-Gen Payment Solution
              </Typography>
              
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 800,
                  mb: 2,
                  fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
                  lineHeight: 1.2,
                  background: 'linear-gradient(90deg, #ffffff, #94a3b8)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Transform Your Payment Experience
              </Typography>
              
              <Typography
                variant="h6"
                sx={{
                  color: '#cbd5e1',
                  mb: 4,
                  fontWeight: 400,
                  lineHeight: 1.6,
                  maxWidth: '90%',
                  mx: { xs: 'auto', md: 0 },
                }}
              >
                Secure, fast, and seamless transactions with RockkPay. Experience the future of digital payments designed for modern businesses and individuals.
              </Typography>
              
              <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                <GradientButton endIcon={<ArrowForwardIcon />} 
                          onClick={handleLoginClick}

                size="large">
                  Get Started Now
                </GradientButton>
                <OutlinedButton size="large">
                  How It Works
                </OutlinedButton>
              </Box>

              <Box sx={{ mt: 5, mb: { xs: 5, md: 0 } }}>
                
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              {/* Main app image */}
              <Box
                component="img"
                src={HerosectionTwo}
                alt="RockkPay App"
                sx={{
                  maxWidth: '100%',
                  maxHeight: { xs: '400px', md: '500px', lg: '550px' },
                  objectFit: 'contain',
                  borderRadius: '16px',
                  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
                  zIndex: 2,
                }}
              />
              
              {/* Decorative glowing circle */}
              <Box
                sx={{
                  position: 'absolute',
                  width: '300px',
                  height: '300px',
                  borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(96, 165, 250, 0.2) 0%, rgba(96, 165, 250, 0) 70%)',
                  zIndex: 1,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  animation: 'pulse 3s infinite',
                  '@keyframes pulse': {
                    '0%': { opacity: 0.6, transform: 'translate(-50%, -50%) scale(0.9)' },
                    '50%': { opacity: 0.8, transform: 'translate(-50%, -50%) scale(1.1)' },
                    '100%': { opacity: 0.6, transform: 'translate(-50%, -50%) scale(0.9)' },
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Feature cards */}
        <Grid container spacing={3} sx={{ mt: { xs: 4, md: 8 } }}>
          <Grid item xs={12} sm={4}>
            <FeatureCard>
              <IconBox>
                <ShieldIcon fontSize="large" />
              </IconBox>
              <Typography variant="h6" component="h3" fontWeight={600} color="#0f172a" gutterBottom>
                Bank-Level Security
              </Typography>
              <Typography variant="body2" color="#64748b" align="center">
                Enterprise-grade security with encryption and fraud detection to protect your transactions.
              </Typography>
            </FeatureCard>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <FeatureCard>
              <IconBox>
                <SpeedIcon fontSize="large" />
              </IconBox>
              <Typography variant="h6" component="h3" fontWeight={600} color="#0f172a" gutterBottom>
                Lightning Fast
              </Typography>
              <Typography variant="body2" color="#64748b" align="center">
                Process transactions in seconds with our optimized payment infrastructure.
              </Typography>
            </FeatureCard>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <FeatureCard>
              <IconBox>
                <DevicesIcon fontSize="large" />
              </IconBox>
              <Typography variant="h6" component="h3" fontWeight={600} color="#0f172a" gutterBottom>
                Multi-Platform
              </Typography>
              <Typography variant="body2" color="#64748b" align="center">
                Seamless experience across all devices with our responsive design and native apps.
              </Typography>
            </FeatureCard>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSectionTwo;